import React, { useEffect, useState } from "react";
import { api, fileUrl } from "../lib/api";
import { AuthImg } from "./AuthImg";
import { Button } from "./ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { History } from "lucide-react";
import { fmtRoDate } from "../lib/dateFmt";

const TYPE_LABELS = {
  liquids: "🛢️ Control lichide",
  photos_actual: "📷 Fotografii actuale",
  tires: "🛞 Profil cauciucuri",
  cleaning: "✨ Curățenie",
  km_friday: "📊 Poza km",
};

export const MaintenanceHistoryButton = ({ personId, carId, label = "ISTORIC" }) => {
  const [open, setOpen] = useState(false);
  const [entries, setEntries] = useState(null);

  useEffect(() => {
    if (!open) return;
    setEntries(null);
    const params = {};
    if (personId) params.person_id = personId;
    if (carId) params.car_id = carId;
    api.get("/me/car-maintenance", { params }).then((r) => setEntries(r.data || [])).catch(() => setEntries([]));
  }, [open, personId, carId]);

  return (
    <>
      <Button
        variant="outline"
        size="sm"
        onClick={() => setOpen(true)}
        className="gap-1.5 font-bold"
        data-testid={`maint-history-btn-${personId || carId}`}
      >
        <History size={14} /> {label}
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-3xl max-h-[90vh] overflow-y-auto" data-testid="maint-history-dialog">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <History size={18} /> Istoric întreținere mașini
            </DialogTitle>
          </DialogHeader>
          {entries === null && <div className="text-center py-8 text-zinc-400">Se încarcă...</div>}
          {entries !== null && entries.length === 0 && (
            <div className="text-center py-8 text-zinc-400 italic">Nicio înregistrare de întreținere.</div>
          )}
          {entries !== null && entries.length > 0 && (
            <ul className="space-y-3">
              {entries.map((e) => (
                <li key={e.id} className="card-flat p-3" data-testid={`maint-hist-entry-${e.id}`}>
                  <div className="flex items-start justify-between gap-2 flex-wrap text-sm">
                    <div>
                      <strong>{TYPE_LABELS[e.type] || e.type}</strong>
                      <span className="text-zinc-500"> · 📅 {fmtRoDate(e.ts)}</span>
                    </div>
                    <div className="text-xs text-zinc-500">
                      {personId ? `🚙 ${[e.car_label, e.car_plate].filter(Boolean).join(" · ") || "—"}${e.driver_label ? ` · 🧑‍✈️ ${e.driver_label}` : ""}` : `👤 ${e.user_label || "—"}${e.driver_label ? ` · 🧑‍✈️ Șofer: ${e.driver_label}` : ""}`}
                    </div>
                  </div>
                  {e.type === "km_friday" && e.data?.km && (
                    <div className="text-sm font-bold mt-1 text-orange-700">📊 {Number(e.data.km).toLocaleString("ro-RO")} km</div>
                  )}
                  {e.type === "tires" && (e.data?.fl_mm || e.data?.fr_mm) && (
                    <div className="text-xs mt-1">🛞 FS:{e.data?.fl_mm ?? "—"} FD:{e.data?.fr_mm ?? "—"} SS:{e.data?.rl_mm ?? "—"} SD:{e.data?.rr_mm ?? "—"} mm</div>
                  )}
                  {e.notes && <div className="text-xs italic text-zinc-600 mt-1">&bdquo;{e.notes}&rdquo;</div>}
                  {(e.image_ids || []).length > 0 && (
                    <div className="grid grid-cols-6 gap-1 mt-2">
                      {e.image_ids.slice(0, 12).map((fid, idx) => (
                        <a key={fid} href={fileUrl(fid)} target="_blank" rel="noreferrer" className="aspect-square block rounded overflow-hidden border border-zinc-200 hover:border-zinc-500">
                          <AuthImg fileId={fid} className="w-full h-full object-cover" alt={`Foto ${idx + 1}`} />
                        </a>
                      ))}
                    </div>
                  )}
                </li>
              ))}
            </ul>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};
